<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>PERSONEL EKLEME EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">PERSONEL EKLEME EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">PERSONEL EKLEME EKRANI</h3>

            <div class="tile-body">
              <form>
                <div class="form-group">
                  <label class="control-label">İSİM:</label>
                  <input
                    v-model="ad"
                    class="form-control"
                    type="text"
                    placeholder="İSİM"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">SOYİSİM</label>
                  <input
                    v-model="soyad"
                    class="form-control"
                    type="text"
                    placeholder="SOYİSİM"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">POZİSYON</label>
                  <input
                    v-model="pozisyon"
                    class="form-control"
                    type="text"
                    placeholder="KÜÇÜK HARFLERLE /  yardımcı  veya operatör yazınız"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">MAAŞ</label>
                  <input
                    v-model="maas"
                    class="form-control"
                    type="text"
                    placeholder="MAAŞ BELİRTİLİRKEN / 16.000 şeklinde nokta koyarak belirtiniz"
                  />
                </div>
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-primary" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Kaydet
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      ad: "",
      soyad: "",
      pozisyon: "",
      maas: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
  },
  methods: {
    reload: function() {
      location.reload();
    },
    sendData: function() {
      if (this.ad == "") {
        this.$swal({
          text: "PERSONEL İSMİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.soyad == "") {
        this.$swal({
          text: "PERSONEL SOYİSMİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.pozisyon == "") {
        this.$swal({
          text: "PERSONEL POZİSYONUNU GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.maas == "") {
        this.$swal({
          text: "PERSONEL MAAŞINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if(this.pozisyon !== "yardımcı"  && this.pozisyon !== "operatör"){
        console.log(this.pozisyon)
        this.$swal({
          text: "İSTENİLEN FORMATLARDA VERİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      }else {
        var url =
          store.state.base_url + "AslanSahalar/createPersonel.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          ad: this.ad,
          soyad: this.soyad,
          pozisyon: this.pozisyon,
          maas: this.maas,
        };
        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data == true) {
              this.$swal({
                text: "Kayıt İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              setTimeout(function() {
                location.reload();
              }, 1250);
            } else {
              this.$swal({
                text: "Hata Oluştu Admine Danışın!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      }
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PersonelEkle.vue